// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"Contacto_contenedor__mfR9P","contenedortabla":"Contacto_contenedortabla__2iFW7"};